"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Dropdown = _interopRequireDefault(require("./Dropdown.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var renderAnchor = function renderAnchor(item, itemId, itemsProps, closeMenu) {
  return R.path([item.key, 'disabled'], itemsProps) ? /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "list-menu-item disabled"
  }, itemsProps[item.key]), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "item-icon",
    icon: item.icon,
    size: 24,
    id: "linkIcon_".concat(itemId, "_").concat(item.key)
  }), item.name) : /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: "list-menu-item",
    href: item.link,
    onClick: R.compose(closeMenu, function () {
      return item.onClick(itemId);
    })
  }, itemsProps[item.key]), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "item-icon",
    icon: item.icon,
    size: 24,
    id: "linkIcon_".concat(itemId, "_").concat(item.key)
  }), item.name);
};
var Dropdown = function Dropdown(_ref) {
  var items = _ref.items,
    itemId = _ref.itemId,
    itemsProps = _ref.itemsProps,
    optionsTracking = _ref.optionsTracking,
    closeMenu = _ref.closeMenu;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    className: "list-menu"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      role: "presentation",
      key: item.name,
      onKeyDown: function onKeyDown() {
        if (!R.path([item.key, 'disabled'], itemsProps)) optionsTracking(item.name, itemId);
      },
      onClick: function onClick() {
        if (!R.path([item.key, 'disabled'], itemsProps)) optionsTracking(item.name, itemId);
      }
    }, item.routerLinkBase && itemId ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, _extends({
      to: "".concat(item.routerLinkBase, "/").concat(itemId)
    }, itemsProps[item.key]), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "item-icon",
      icon: item.icon,
      size: 24,
      id: "routeItemIcon_".concat(itemId)
    }), item.name) : renderAnchor(item, itemId, itemsProps, closeMenu));
  })));
};
Dropdown.propTypes = {
  closeMenu: _propTypes["default"].func,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    itemId: _propTypes["default"].number,
    link: _propTypes["default"].string,
    routerLinkBase: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    props: _propTypes["default"].shape({
      disabled: _propTypes["default"].bool
    })
  })).isRequired,
  itemId: _propTypes["default"].string,
  optionsTracking: _propTypes["default"].func,
  itemsProps: _propTypes["default"].shape({})
};
Dropdown.defaultProps = {
  closeMenu: function closeMenu() {},
  itemId: '',
  itemsProps: {},
  optionsTracking: function optionsTracking() {}
};
Dropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dropdown",
  "props": {
    "closeMenu": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "itemId": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "itemsProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "optionsTracking": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "items": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "icon": {
              "name": "string",
              "required": false
            },
            "itemId": {
              "name": "number",
              "required": false
            },
            "link": {
              "name": "string",
              "required": false
            },
            "routerLinkBase": {
              "name": "string",
              "required": false
            },
            "onClick": {
              "name": "func",
              "required": false
            },
            "props": {
              "name": "shape",
              "value": {
                "disabled": {
                  "name": "bool",
                  "required": false
                }
              },
              "required": false
            }
          }
        }
      },
      "required": true
    }
  }
};
var _default = Dropdown;
exports["default"] = _default;